
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sustain-chain",
      function () {
        return require("private-next-pages/sustain-chain/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sustain-chain"])
      });
    }
  